import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Fest {
    id: string;
    name: string;
    startDate: string;
    endDate: string;
    status: string;
    organiser?: string;
    logo?: string;
    description?: string;
    pointStructure?: {
        position?: Record<string, number>;
        grade?: Record<string, number>;
        gradeThresholds?: Record<string, number | { min: number; max: number }>;
    };
    defaultMaxParticipantsIndividual?: number;
    defaultMaxParticipantsGroup?: number;
}

interface FestState {
    fests: Fest[];
    currentFest: Fest | null;
    loading: boolean;
    error: string | null;
        stats: {
        totalEvents: number;
        totalParticipants: number;
        activeFest: string;
        resultsPublished: string;
        categoryData?: { x: string; y: number }[];
        eventStatusData?: number[];
        upcomingEvents?: { name: string; date: string; participants: number; status: string }[];
        announcements?: any[];
        unassignedEvents?: any[];
    } | null;
}

const initialState: FestState = {
    fests: [],
    currentFest: null,
    loading: false,
    error: null,
    stats: null,
};

const festSlice = createSlice({
    name: 'Fest',
    initialState,
    reducers: {
        setFests: (state, action: PayloadAction<Fest[]>) => {
            state.fests = action.payload;
            state.loading = false;
        },
        setCurrentFest: (state, action: PayloadAction<Fest | null>) => {
            state.currentFest = action.payload;
        },
        setStats: (state, action: PayloadAction<FestState['stats']>) => {
            state.stats = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const { setFests, setCurrentFest, setStats, setLoading, setError } = festSlice.actions;
export default festSlice.reducer;
